"use client";

import { ArrowLeft2Icon, ArrowRight2Icon } from "@grupa-pracuj/ui-system/icons";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { getResolvedArchiveSearchParams } from "@/utils";
import styles from "./Pagination.module.css";

const Pagination = ({ hideNext }: { hideNext?: boolean }) => {
  const searchParams = useSearchParams();

  const { year, month, pageNumber } = getResolvedArchiveSearchParams({
    year: searchParams.get("year"),
    month: searchParams.get("month"),
    pageNumber: searchParams.get("pageNumber"),
  });

  const searchYear = year;
  const searchMonth = month;
  const searchPage = Number(pageNumber);

  const showSearchPage = !hideNext || (hideNext && searchPage > 1);

  return (
    <nav className={styles.container} aria-label="Paginacja ofert archiwalnych">
      {searchPage > 1 && (
        <Link
          className={styles.button}
          href={`/?year=${searchYear}&month=${searchMonth}&pageNumber=${searchPage - 1}`}
          rel="prev"
        >
          <ArrowLeft2Icon /> Poprzednia
        </Link>
      )}
      {showSearchPage ? <span aria-current="page">{searchPage}</span> : null}
      {!hideNext && (
        <Link
          className={styles.button}
          href={`/?year=${searchYear}&month=${searchMonth}&pageNumber=${searchPage + 1}`}
          rel="next"
        >
          Następna <ArrowRight2Icon />
        </Link>
      )}
    </nav>
  );
};

export default Pagination;
